import { render, staticRenderFns } from "./TermSections.vue?vue&type=template&id=0f5c1ca4&scoped=true&"
import script from "./TermSections.vue?vue&type=script&lang=js&"
export * from "./TermSections.vue?vue&type=script&lang=js&"
import style0 from "./TermSections.vue?vue&type=style&index=0&id=0f5c1ca4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f5c1ca4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f5c1ca4')) {
      api.createRecord('0f5c1ca4', component.options)
    } else {
      api.reload('0f5c1ca4', component.options)
    }
    module.hot.accept("./TermSections.vue?vue&type=template&id=0f5c1ca4&scoped=true&", function () {
      api.rerender('0f5c1ca4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/tenants/TermSections.vue"
export default component.exports